export const fileDownload = (data: string | Blob, type: string, target = '_blank', fileName?: string) => {
  const a = document.createElement('a');
  document.body.appendChild(a);

  const blob = new Blob([data], {
    type,
  });

  const url = window.URL.createObjectURL(blob);
  a.href = url;
  a.target = target;
  if (fileName) {
    a.download = fileName;
  }
  a.click();
  window.URL.revokeObjectURL(url);
};

export const imageFileDownload = (data: File | Blob | string, fileName: string, type?: string) => {
  const a = document.createElement('a');
  document.body.appendChild(a);

  const blob = new Blob([data], {
    type,
  });

  const url = window.URL.createObjectURL(blob);
  a.href = url;
  a.download = fileName;
  a.click();
  window.URL.revokeObjectURL(url);
};
